import  { HomePageFAQSection } from '../components/3D_Home/FAQSection';
import CanvasSequenceHero from '../components/3D_Home/ImageSequenceHero';
import BackgroundWrapper from '../components/Reusable/BackgroundWrapper';
import SpatialEngineering from '../components/3D_Home/SpatialEngineering';
import EnterpriseImpact from '../components/3D_Home/EnterpriseImpact';
import Companies from '../components/3D_Home/Companies';
import Testimonials from '../components/3D_Home/Testimonials';
import XRSolutions from '../components/3D_Home/XRSolutions';
import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import VideoSequenceHero from '../components/3D_Home/SequenceHero';

gsap.registerPlugin(ScrollTrigger);

const Home = () => (
  <div className="bg-black flex flex-col max-w-[100vw] custom-scrollbar">
    <BackgroundWrapper>
      {/* <VideoSequenceHero /> */}
      <CanvasSequenceHero />
      <SpatialEngineering />
      <div>
        <div className="container mx-auto px-4 text-center py-10 md:py-20 text-white">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-telegraf mb-4">
            XR Solutions for every Industry
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-300 max-w-3xl mx-auto">
            Our customers achieve breakthroughs, visualize experiences faster
            and drive down costs. See how you can too.
          </p>
        </div>
      </div>
      <XRSolutions />
      <EnterpriseImpact />
      <Companies />
    </BackgroundWrapper>
    <Testimonials />
    <HomePageFAQSection />
  </div>
);

export default Home;

// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import XRSection from '../components/HomePage/XRSection';
// import EnterpriseImpact from '../components/HomePage/EnterpriseImpact';
// import VisualEditer from '../components/HomePage/VisualEditer';
// import XRSolutions from '../components/HomePage/XRSolutions';
// import FAQSection from '../components/HomePage/FAQSection';
// import GetStartedSection from '../components/HomePage/GetStartedSection';
// import Modal from '../components/ui/Modal';
// import { ModalDefaultComponent } from '../components/ui/UtilsLayout';
// import ButtonComponent from '../components/ui/ButtonComponent';
// import NavbarComponent from '../components/HomePage/NavBarComponent';

// const Home = () => {
//   const [open, setOpen] = useState(false);
//   const [mess, setMess] = useState('');
//   const navigate = useNavigate();

//   const closeModal = () => {
//     setOpen(false);
//   };

//   const loginAgain = () => {
//     setOpen(false);
//     navigate('/');
//     // store.dispatch(set_open_log_in(true));
//   };

//   return (
//     <div className="h-full bg-[#121316] flex flex-col min-h-screen max-w-[100vw] overflow-hidden relative custom-scrollbar">
//       <NavbarComponent />
//       <XRSection />
//       <EnterpriseImpact />
//       <VisualEditer />
//       <XRSolutions />
//       <FAQSection />
//       <GetStartedSection />

//       {/* Modal for alert message */}
//       <Modal isOpen={open} closeModal={closeModal}>
//         <ModalDefaultComponent>
//           <h2 className="text-lg text-center sm:text-xl md:text-[18px] lg:text-[20px] font-medium font-inter text-white mb-5 leading-snug">
//             {mess}
//           </h2>
//           <div className="flex justify-center gap-4">
//             <ButtonComponent
//               className="bg-[#EE2B2A] hover:bg-[#252729]"
//               onClick={loginAgain}
//             >
//               Login Again
//             </ButtonComponent>
//             <ButtonComponent
//               className="bg-[#252729] hover:bg-[#EE2B2A]"
//               onClick={() => navigate('/contact')}
//             >
//               Contact Us
//             </ButtonComponent>
//           </div>
//         </ModalDefaultComponent>
//       </Modal>
//     </div>
//   );
// };

// export default Home;
